"use client"

import { TemplatesPage } from "../../../modules/admin/templates"

interface TemplatesProps {
  sidebarOpen?: boolean
}

export default function Templates({ sidebarOpen }: TemplatesProps) {
  return (
    <div
      className={`w-full mb-6 p-4 lg:p-6 overflow-x-hidden ${!sidebarOpen ? "max-w-none" : "max-w-7xl mx-auto"}`}
    >
      <TemplatesPage />
    </div>
  )
}

